export default "__VITE_ASSET__4009f095__"